<template>
<div>
    <business-partner-contact-information-form :getBusinessPartnerContactInformationList="getBusinessPartnerContactInformationList" ref="businessPartnerContactInformationFormModal"></business-partner-contact-information-form>
    <b-row>
        <b-col class="col-12">
            <div style="float:right;" class="custom-search d-flex justify-content-end">
                <b-form-group>
                    <div class="d-flex align-items-center">
                        <b-button style="float:right; border-color:#6B7280; color:#374151;" size="sm" variant="outline-secondary" @click="getInfo(0)">{{ $t('businessPartnerContactInformation.add') }}</b-button>
                    </div>
                </b-form-group>
            </div>
        </b-col>
    </b-row>
    <!-- table -->
    <vue-good-table id="businessPartnerContactInformationTable" ref="businessPartnerContactInformationTable" :columns="columns" :rows="rows" styleClass="vgt-table condensed tableSize" :select-options="{
            enabled: false,
            selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
            selectionInfoClass: 'custom-class',
            selectionText: 'rows selected',
            clearSelectionText: 'clear',
            disableSelectInfo: true, // disable the select info panel on top
            selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
          }" theme="my-theme">
        <div slot="emptystate">
            {{ $t('dataTable.data_not_found') }}
        </div>
        <!-- Row: Table Row -->
        <template slot="table-column" slot-scope="props">
            <span v-if="props.column.field === 'contactType'" class="text-nowrap">
                {{ $t('businessPartnerContactInformation.contact_type') }}
            </span>
            <span v-else-if="props.column.field === 'information'" class="text-nowrap">
                {{ $t('businessPartnerContactInformation.information') }}
            </span>
            <span v-else-if="props.column.field === 'process'" class="text-nowrap"></span>
        </template>
        <!-- Column: Table Column -->
        <template slot="table-row" slot-scope="props">
            <!-- Column: Process -->
            <span v-if="props.column.field === 'process'">
                <list-actions-dropdown :actions="[
                    { icon: 'EditIcon', label: $t('others.edit'), handler: () => getInfo(props.row.id) },
                    { icon: 'XIcon', label: $t('others.delete'), color: '#DC2626', handler: () => deleted(props.row) }
                ]" />
            </span>
        </template>
    </vue-good-table>
</div>
</template>

    
<script>
export default {
    props: {
        businessPartnerId: Number,
    },
    data() {
        return {
            dir: false,
            columns: [{
                    label: this.$t('businessPartnerContactInformation.contact_type'),
                    field: `contactType`,
                },
                {
                    label: this.$t('businessPartnerContactInformation.information'),
                    field: `information`,
                },
                {
                    label: '',
                    field: 'process',
                    width: '10em',
                    sortable: false
                },
            ],
            rows: [],
            searchTerm: '',
        }
    },
    mounted() {
        this.getBusinessPartnerContactInformationList()
    },
    methods: {
        async deleted(data) {
            data = {
                id: data.id
            }
            const controller = {
                name: 'BusinessPartnerContactInformation'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$DeleteConfirm().then(result => {
                if (result.value) {
                    this.$store.dispatch('moduleAuth/delete', payload).then((response) => {
                        if (response.data.resultStatus == true) {
                            this.$DeleteAlert()
                            this.getBusinessPartnerContactInformationList()
                        } else {
                            this.$WarningAlert(response.data.resultMessage)
                            this.getBusinessPartnerContactInformationList()
                        }
                    })
                }
            })
        },
        async getInfo(id) {
            this.$refs.businessPartnerContactInformationFormModal.showInfo(id,this.businessPartnerId)
        },
        getBusinessPartnerContactInformationList() {
            this.rows = []
            const data = {
                id: this.businessPartnerId
            }
            const controller = {
                name: 'BusinessPartnerContactInformation',
                actionName: 'GetBusinessPartnerContactInformationListByBusinessPartnerId'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    response.data.businessPartnerContactInformationList.forEach(element => {
                        this.rows.push(element)
                    })
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        }
    },
}
</script>

    
<style lang="scss">
.tableSize {
    font-size: 13px !important;
    border-collapse: collapse;
    width: 100%;
    max-width: 100%;
    table-layout: auto;
}
</style>
